// cluster/components/extendBillingForm/hooks/useExtendBillingForm.ts
import { useState, useCallback } from 'react'
import { ClusterInterface } from '../../../../../common/types/interfaces'
import { getApi } from '../../../../../api/api'

type Props = {
  cluster: ClusterInterface| undefined
  setModalActive: (state: boolean) => void
  getList: () => void
}

export const useExtendBillingForm = ({ cluster, setModalActive, getList }: Props) => {
  const [paidUntil, setPaidUntil] = useState('')
  const [loading, setLoading] = useState(false)
  const api = getApi()

  const minDate = new Date().toISOString().split('T')[0]

  const handleDateChange = useCallback(
    (value: string) => {
      if (!value) {
        setPaidUntil('')
        return
      }
      if (value < minDate) {
        setPaidUntil(minDate)
        return
      }
      setPaidUntil(value)
    },
    [minDate],
  )

  const submit = useCallback(async () => {
    if (!paidUntil || !cluster?.id) return

    setLoading(true)
    try {
      await api.extendBilling({
        clusterId: cluster.id,
        paidUntil: `${paidUntil} 23:59:59`,
      })
      setModalActive(false)
      getList()
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [paidUntil, cluster?.id, api, setModalActive, getList])

  return {
    paidUntil,
    loading,
    minDate,
    handleDateChange,
    submit,
  }
}
